<template>
  <label :for="name" class="block mb-4">
    <span class="text-base font-semibold text-gray-800">{{ label }}</span>
    <select v-model="internalModel" :value="internalModel" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" :required="required" @input="inputMethod">
      <option disabled value="">{{ placeholder }}</option>
      <option v-for="option in options" :key="option" :value="option">{{option}}</option>
    </select>
    <span class="text-gray-800 text-sm">{{ description }}</span>
  </label>
</template>

<script>
export default {
  // eslint-disable-next-line
  props: {
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "Please select an option",
    },
    required: Boolean,
  },
  computed: {
    internalModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  emits: ["update:modelValue"],
  methods: {
    // eslint-disable-next-line
    inputMethod: function($event) {
      this.internalModel = $event.target.value;
    }
  }
}
</script>
